/** Where the favourites list is kept on the phone. Its own file so sign-out can clear it without importing the slice. */
export const FAVORITES_KEY = '@salon_favorites';
